import * as React from "react";
import {__RouterContext} from "react-router";

import {
    useMarkConversion,
    type Conversion,
    type ConversionName,
    type MinorConversionData,
} from "@khan/analytics-learning-time";

// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedLink from "../link-package/deprecated-link.ts";

import {getLinkElement, onClickWithMarkConversions} from "./utils.ts";

type LinkProps = JSX.LibraryManagedAttributes<
    typeof DeprecatedLink,
    React.ComponentProps<typeof DeprecatedLink>
>;
type SharedLinkProps = Omit<LinkProps, "href">;

type Props = SharedLinkProps & {
    forceServer?: boolean;
    to: string;
    conversions?: ReadonlyArray<ConversionName | Conversion>;
    inputRef?: any;
    minorConversions?: ReadonlyArray<MinorConversionData>;
    ref?: unknown;
};

/**
 * @deprecated Please use `Link` from `@khanacademy/wonder-blocks-link` instead.
 */
const ClientLink = ({
    forceServer,
    to,
    onClick,
    conversions,
    inputRef,
    minorConversions,
    ...linkProps
}: Props): React.ReactElement => {
    const router = React.useContext(__RouterContext);
    const markConversion = useMarkConversion();
    return (
        <DeprecatedLink
            {...linkProps}
            href={to}
            ref={inputRef}
            element={getLinkElement(to, router, forceServer)}
            onClick={onClickWithMarkConversions(
                markConversion,
                onClick,
                conversions,
                minorConversions,
            )}
        />
    );
};

export default ClientLink;
